import React from 'react';
import {
    Link
} from "react-router-dom";

const selcategory = (props) => {
    return (
        <React.Fragment>
            <link
                rel="stylesheet"
                href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
            />
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5 px--xs-0 text-center mx-auto">
                            <h6 className="first-heading">Are you looking for a per person or group deal ?
                            </h6>
                        </div>

                        <div className="col-md-10 px--xs-0 mt-3 mt-xl-4 mx-auto">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="choose-deal-both">
                                        <Link to={process.env.PUBLIC_URL+"/category/allday/view-all/"+props.match.params.id} className="text-wrapper">
                                        <img src={`${process.env.PUBLIC_URL}/image/choose-pp.png`} alt="perperson" />
                                            <div className="choose-deal-both-overlay">
                                                   <div className="overlay-headings"> <span
                                                        className="my-element animate__animated animate__heartBeat repeat">PER PERSON DEAL</span></div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-4 mt-md-0">
                                    <div className="choose-deal-both">
                                        <Link to={process.env.PUBLIC_URL+"/category/oneday/view-all/"+props.match.params.id} className="text-wrapper">
                                        <img src={`${process.env.PUBLIC_URL}/image/choose-gp.png`} alt="groupdeal" />
                                            <div className="choose-deal-both-overlay">
                                                <div className="overlay-headings">
                                                    <span
                                                        className="my-element animate__animated animate__heartBeat repeat">Group Deal</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default selcategory;